import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ConfirmationModalProps } from "@/hooks/useConfirmationModal";

export const EarlyCutoffWarningModal = ({ isOpen, onClose, onContinue }: ConfirmationModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <Modal.Header>Update Early Cutoff</Modal.Header>
        <Modal.Body>
            Timed entry requires an <b>Early Cutoff</b> other than <b>end of business</b>. We will update Early Cutoff
            to <b>start of event</b> for you. Would you like to proceed?
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <SubmitButton onClick={() => onContinue(true)}>Confirm</SubmitButton>
        </Modal.Footer>
    </Modal>
);
